import React from 'react';
import ReactDOM from 'react-dom/client';
import Router from './Router.tsx';
import './main.scss';
import 'app-layout-frame/dist/index.css';
import { AuthProvider } from './contexts/AuthContext.tsx';
import TranslationProvider from './contexts/TranslationContext.tsx';
import { Modal } from '@7shifts/sous-chef';
import '@7shifts/sous-chef/dist/index.css';
import SousChefProvider from 'sharedComponents/SousChefProvider';
import { initializeSentry } from 'utils/logging.ts';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import VersionBadge from 'sharedComponents/VersionBadge';
import UpdateAvailableBanner from 'sharedComponents/UpdateAvailableBanner';
import { installChunkErrorRecovery } from 'utils/appUpdate';

initializeSentry();

// Antes de renderizar: se um chunk lazy falhar por causa de deploy novo, o app
// se recarrega sozinho furando o cache, em vez de cair na tela de erro.
installChunkErrorRecovery();

Modal.setAppElement('#root');

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <TranslationProvider>
            <SousChefProvider>
                <AuthProvider>
                    <DndProvider backend={HTML5Backend}>
                        <Router />
                        <VersionBadge />
                        <UpdateAvailableBanner />
                    </DndProvider>
                </AuthProvider>
            </SousChefProvider>
        </TranslationProvider>
    </React.StrictMode>
);
